import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";
import { AlterarIndicadorPlanoContaResultadoModel } from "../models/planoContaResultado/alterarIndicadorPlanoContaResultadoModel";
import { BuscaPlanoContaResultadoModel } from "../models/planoContaResultado/buscaPlanoContaResultadoModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";

export const alterarIndicadorPlanoContaResultado = createAsyncThunk("/PlanoContaResultado/AlterarIndicadorPlanoContaResultado", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/PlanoContaResultado/AlterarIndicadorPlanoContaResultado/", payload.value);
    toastSucess("Plano de conta associado ao resultado do sorteio");
    dispatch(setLoading(false));

    dispatch(listarPlanoContaResultado(payload.busca));
    dispatch(listarIndicadorCalculoResultado());
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const listarPlanoContaResultado = createAsyncThunk("/PlanoContaResultado/ListarPlanoContaResultado", async (args: BuscaPlanoContaResultadoModel) => {
  try {
    const data = await api.get("/PlanoContaResultado/ListarPlanoContaResultado", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarIndicadorCalculoResultado = createAsyncThunk("/PlanoContaResultado/ListarIndicadorCalculoResultado", async () => {
  try {
    const data = await api.get("/PlanoContaResultado/ListarIndicadorCalculoResultado");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
